// Styles for PropertyPortalMerchandising go here.
import styled from 'styled-components';

export const StyledPropertyPortalMerchandising = styled.div``;
